import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  GET,
  POST,
} from '@app/core/api';
import {ProductFeatureFeedbackStep1Dto, ProductFeatureFeedbackStep2Dto} from '@app/core/dto';
import type {ProductFeatureFeedbackPendingResult} from '@app/core/interfaces/product-feature-feedback-pending-result.interface';

@ApiController('api/app/product-features')
@Injectable({
  providedIn: 'root',
})
export class ProductFeatureApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('/enabled')
  getEnabled(): Observable<ApiResponse<string[]>> {
    return {} as Observable<ApiResponse<string[]>>;
  }

  @GET('/feedback-pending')
  getFeedbackPending(): Observable<ApiResponse<ProductFeatureFeedbackPendingResult[]>> {
    return {} as Observable<ApiResponse<ProductFeatureFeedbackPendingResult[]>>;
  }

  @POST('/feedback/step-1')
  submitFeedbackStep1(
    @Body() dto: ProductFeatureFeedbackStep1Dto,
  ): Observable<ApiResponse<number>> {
    return {} as Observable<ApiResponse<number>>;
  }

  @POST('/feedback/step-2')
  submitFeedbackStep2(
    @Body() dto: ProductFeatureFeedbackStep2Dto,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}
